import React, { useEffect } from 'react'
import { Button } from 'antd'
import { MailOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useStores } from '../../cls/stores/MobXProvider'
import { actLoadUser } from '../../stores/users/actions'
import { DO_LOAD } from '../../config'

/**
 * QuickUserContact component provides a button to initiate contact with a user.
 * It fetches user details based on the provided user ID and navigates to the contact page
 * with the user's email and name as query parameters.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.id - The ID of the user to contact.
 * @returns {JSX.Element} The rendered QuickUserContact component.
 */
const QuickUserContact = ({ id }) => {
	const navigate = useNavigate()
	const { users } = useStores()
	const user = users.requireUserById(id)

	useEffect(() => {
		// Fetch only if user is empty
		if (user.loaded === DO_LOAD) {
			actLoadUser(users, id, false)
				.catch(console.error)
				.finally(() => {
					users.saveState()
				})
		}
	}, [id, user.loaded])

	const handleContactClick = () => {
		let user_name = user.name ? user.name : user.email ? user.email : id
		navigate(`/contact-us?email=${user.email}&user_name=${user_name}`)
	}

	return (
		<Button
			className="we-quick-user-contact"
			icon={<MailOutlined />}
			onClick={handleContactClick}
		>
			Email
		</Button>
	)
}

export default QuickUserContact

QuickUserContact.propTypes = {
	id: PropTypes.string.isRequired
}
